import React from 'react';
import OrderResumeTemplate from 'view/templates/order-resume';

export default function OrderResumePage() {
  return <OrderResumeTemplate />;
}
